import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Field from '../field';
import Input from '../field/input';
import fieldTypes from '../../form/field-types';

const FileUpload = forwardRef(({ fieldKey, field }, ref) => {
  const { machineName, infoRedactionRequired, name } = field;
  return (
    <>
      <Input key={fieldKey} name={machineName} ref={ref} {...field} />
      {infoRedactionRequired && (
        <Field
          key="redaction"
          type={fieldTypes.CHECKBOXES}
          label="Sensitive information must be redacted"
          name={`${name}[redaction]`}
          options={[
            {
              value: 'true',
              label: `I confirm that the documents I'm attaching are redacted`,
            },
          ]}
          required
        />
      )}
    </>
  );
});

FileUpload.displayName = 'FileUpload';

FileUpload.propTypes = {
  fieldKey: PropTypes.string,
  field: PropTypes.object,
  refFn: PropTypes.func,
};

export default FileUpload;
